import { Component, ElementRef, Inject, OnInit, SecurityContext, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UserService } from 'src/services/user.service';
import { IDMSUserPhotoResponse } from 'src/models/api-response/user-idms-photo-response.interface';
import { environment } from 'src/environments/environment';
import { timer } from 'rxjs';
import { take } from 'rxjs/operators';


@Component({
    selector: 'app-edit-user-photo',
    templateUrl: './edit-user-photo.component.html',
    styleUrls: ['./edit-user-photo.component.css'],
    standalone: false
})
export class EditUserPhotoComponent implements OnInit {

  currentImage: string | undefined = undefined;
  badgingOfficeUsersList: { name: string, photo: SafeResourceUrl }[] = [];
  showBrowsePhoto: boolean = false;
  BrowsedPhoto: any;
  actualPhotoString: string = "";
  activatedRoute: any;
  router: any;
  userId: any;
  listIDMSUserPhoto : IDMSUserPhotoResponse[] =[];
  errorMessage : string ="";
  infoMessage :string ="";
  searchcount: number =0;
  disableUpdate : boolean = true;
  progressBar:boolean = false;
  clickhere : string ="";
  serviceUrl : string ="";
  
  constructor(private dialogRef: MatDialogRef<EditUserPhotoComponent>, @Inject(MAT_DIALOG_DATA) public data: { imageSrc: string, firstName: string, lastName: string, userId: number , supervisorid : number , loggedUserId : number, upid :string},
    private userService: UserService, private snackBar: MatSnackBar, private domSanitizer: DomSanitizer) {
      // loggedUserId and supervisorid is not in use. but not removing this for future in case we need.
  }

  ngOnInit(): void {
    this.showBrowsePhoto = false;
    if (this.data.imageSrc) {
      //Photo from DB.
      this.currentImage = this.domSanitizer.sanitize(SecurityContext.URL, this.data.imageSrc)?.replace('data:Image/jpg;base64,', '');
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onGetImageFromBadgingOffice(): void {
    this.userService.getUserImageFromBadgingOffice(this.data.firstName, this.data.lastName).subscribe(res => {
      if (res.photoLs == null || res.photoLs.length < 1) {
        this.snackBar.open(res.response, 'ok', {
          duration: 5000
        });
        return;
      }
      let info = res.photoLs[0];
      let sanitizedImage = this.domSanitizer.bypassSecurityTrustResourceUrl("data:Image/jpg;base64," + info.photo);
      this.badgingOfficeUsersList.push({ name: info.FirstName + ' ' + info.LastName, photo: sanitizedImage });
      this.BrowsedPhoto = sanitizedImage;

      // Take the badge image and convert it so it can be saved.
      var canvas = document.createElement("canvas");
      var imageElement = document.createElement("img");
      

      // Give the browser time to create the elements.
      setTimeout(() => {
        imageElement.setAttribute('src', this.domSanitizer.sanitize(SecurityContext.RESOURCE_URL, sanitizedImage) ?? "");
        canvas.width = imageElement.width;
        canvas.height = imageElement.height;

        var context = canvas.getContext("2d");
        context?.drawImage(imageElement, 0, 0);

        var base64Image = canvas.toDataURL("image/jpeg");
        this.actualPhotoString = base64Image.replace(/data:image\/jpeg;base64,/g, '');

      }, 500);
      // console.log('actualPhotoString for Badge:', this.actualPhotoString);
    });

  } 
   
  onGetIDMSImageFromBadgingOffice(): void {
    
    if(this.data.upid == '' || this.data.upid == null)
    {
      this.disableUpdate = true;
      this.errorMessage = environment.noPhotoMesssage;
      this.serviceUrl =environment.missingUserLink;
      this.clickhere = environment.clickhere;
      return;
    }

    
    this.errorMessage='';
    this.infoMessage='';
    this.serviceUrl = '';
    this.clickhere = '';
    this.progressBar=true;
    
    this.userService.getUserImageFromIDMSBadgingOffice(Number(this.data.upid)).subscribe(res => {
      this.listIDMSUserPhoto =res;  
      if(this.listIDMSUserPhoto.length ==0)
      {
        this.progressBar=false;
        this.disableUpdate = true;
        this.errorMessage = environment.noPhotoMesssage ;
        this.serviceUrl =environment.missingUserLink;
        this.clickhere = environment.clickhere;
        return;
      }
      this.listIDMSUserPhoto.forEach(item => {
        item.imageSrc =  this.domSanitizer.bypassSecurityTrustResourceUrl("data:Image/jpg;base64," + item.picture);
        //this.currentImage = "data:Image/jpg;base64," + item.picture;
        //this.currentImage = this.domSanitizer.sanitize(SecurityContext.URL, item.picture)?.replace('data:Image/jpg;base64,', '');
        this.BrowsedPhoto = item.imageSrc;
       
        //this.actualPhotoString =item.picture;
        var canvas = document.createElement("canvas");
        var imageElement = document.createElement("img");
  
        // Give the browser time to create the elements.
        setTimeout(() => {
         
          imageElement.setAttribute('src', this.domSanitizer.sanitize(SecurityContext.RESOURCE_URL, item.imageSrc) ?? "");
          canvas.width = imageElement.width;
          canvas.height = imageElement.height;
  
          var context = canvas.getContext("2d");
          context?.drawImage(imageElement, 0, 0);
  
          var base64Image = canvas.toDataURL("image/jpeg");
          
          this.actualPhotoString = base64Image.replace(/data:image\/jpeg;base64,/g, '');
        }, 500);
        
        this.progressBar=false;
        this.infoMessage = " : Badge";
        this.disableUpdate = false;
      });
    },
    error => {
      this.progressBar=false;
      this.errorMessage=environment.badgingservernotconnected;
      this.clickhere = environment.clickhere;
      this.serviceUrl =environment.missingUserLink;
    }
  );
  } 
   
  //when user browses a photo this func is called
  onImageSelect(event: any) {
    this.showBrowsePhoto = true;

    if (event.target.files && event.target.files.length) {
      const reader = new FileReader();
      const file = event.target.files[0];

      if (file && /image/.test(file.type)) {
        reader.readAsDataURL(file);
        reader.onload = () => {
          const varImgstr = (<string>reader.result).split(',')[1];

          this.BrowsedPhoto = this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file));
          this.actualPhotoString = varImgstr;
          this.disableUpdate = false;
          this.infoMessage = " : Browse";
          //console.log('actualPhotoString for selected Image:', this.actualPhotoString);
        };
      }

    }
  }



  CancelSave(): void {
    //close the pop up window
    //console.log("in Cancel Save()");
    this.dialogRef.close();
  }


  SaveImage() {
    //console.log("in save image");
    //console.log(this.actualPhotoString);
    //pop up
    if(this.actualPhotoString == '')
    {
      this.errorMessage= "No photo is selected to update as a profile photo";
      return;
    }

    var userpicInfo = {
      userinfoid: this.data.userId,
      pic: this.actualPhotoString
    };
    //console.log("userPicInfo: ", userpicInfo);

    this.userService.uploadbadgeimage(userpicInfo).subscribe(updateRes => {
      if (updateRes !== 'Picture Uploaded Succesfully') {
        this.snackBar.open(updateRes, 'ok', {
          duration: 5000
        });
      }
      // setTimeout(() => {
      this.dialogRef.close();
      window.location.reload();
      // }, 5000);
    });
  }
}
